import update from "immutability-helper";
import { useCallback } from "react";
import Card from "./Card";

const Container = ({ setImageUrl, imageUrl, handleRemoveImage }) => {
  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      setImageUrl((prevCards) =>
        update(prevCards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, prevCards[dragIndex]],
          ],
        })
      );
    },
    [setImageUrl]
  );

  const renderCard = useCallback(
    (card, i) => {
      return (
        <Card
          key={i + 1}
          index={i}
          id={i + 1}
          moveCard={moveCard}
          image={process.env.REACT_APP_API_IMAGE_URL +card}
          handleRemoveImage={handleRemoveImage}
        />
      );
    },
    [moveCard, handleRemoveImage]
  );

  const imageArray = Array.isArray(imageUrl) ? imageUrl : [];
 
  return imageArray.length > 0 ? (
    <>
    
      {imageArray.map((card, i) => renderCard(card, i))}
    </>
  ) : (
    <p></p>
  );
};

export default Container;
